<template>
  <div>
    <Select
      id="event-form-select-input"
      :options="forms"
      @input="selectForm"
      titleProperty="name"
    />
    <div id="playlist-fields" v-if="chosenForm">
      <library-form-item
        v-for="(field, index) in chosenForm.fields"
        :key="index"
        :field="field"
        @delete-match="deleteMatch(field)"
        @find-match="findMatch(field)"
      />
      <div class="streaming-tracks" v-if="chosenForm.streamingTracks">
        <div
          class="streaming-track"
          v-for="(track, index) in chosenForm.streamingTracks"
          :key="index"
        >
          <BaseListItem @click="findStreamingMatch(track)">
            <Track :track="track" />
          </BaseListItem>
          <library-form-match
            v-if="track.libraryMatch"
            :track="track.libraryMatch"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Select from "../../Elements/Select.vue";
import LibraryFormItem from "../../UI/ListItems/Library/LibraryFormItem.vue";
import Track from "../../Spotify/Track.vue";
import BaseListItem from "../../UI/ListItems/BaseListItem.vue";
import LibraryFormMatch from "../../UI/ListItems/Library/LibraryFormMatch.vue";
export default {
  data() {
    return {};
  },
  computed: {
    forms() {
      return this.event.forms;
    },
  },
  methods: {
    selectForm(form) {
      this.$emit("form-chosen", form);
    },
    deleteMatch(field) {
      delete field.libraryMatch;
    },
    findMatch(field) {
      this.$emit("find-match", field);
    },
    findStreamingMatch(track) {
      this.$emit("find-streaming-match", track);
    },
  },
  created() {
    console.log(this.chosenForm);
  },
  components: {
    Select,
    LibraryFormItem,
    Track,
    BaseListItem,
    LibraryFormMatch,
  },
  emits: ["form-chosen", "find-match", "find-streaming-match"],
  props: ["event", "chosenForm"],
};
</script>
<style scoped>
#event-form-select-input {
  position: sticky;
  top: 0;
  z-index: 2;
}

.streaming-track {
  margin: 5px 0;
}
</style>
